var $d80f30fe86c95741$exports = {};
$d80f30fe86c95741$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, "\xA0: ").concat(args.value);
  },
  "colorPicker": "S\xE9lecteur de couleurs",
  "colorSwatch": "\xC9chantillon de couleurs",
  "transparent": "Transparent",
  "twoDimensionalSlider": "Curseur\xA02D"
};
export { $d80f30fe86c95741$exports as default };